import React, { ReactNode, forwardRef } from 'react';
import classNames from 'classnames';

import css from './style.module.scss';

interface IProps {
  children: ReactNode;
  height?: 'full';
  width?: 'full';
  align?: 'center';
  type?: 'flex';
  direction?: 'column'
}

const PageContentInner = forwardRef<HTMLDivElement, IProps>(function PageContentInner(
  { children, height, width, align, type, direction },
  ref,
) {
  return (
    <div
      id="contentInner"
      ref={ref}
      className={classNames(css.page__contentInner, {
        [css[`page__contentInner_height_${height}`]]: height,
        [css[`page__contentInner_width_${width}`]]: width,
        [css[`page__contentInner_align_${align}`]]: align,
        [css[`page__contentInner_type_${type}`]]: type,
        [css[`page__contentInner_direction_${direction}`]]: direction,
      })}
    >
      {children}
    </div>
  );
});

export default PageContentInner;
